import { DELIVERY_CLIENT_ID } from "../keys"

// End Points of our backend
const GET_RESTAURANTS_ENDPOINT = "/api/v1/delivery/restaurants/merchants/"
const VERIFY_EMAIL = "/api/v1/verify-email/"
const REGISTER_EMAIL = "/api/v1/register/email/"
const LOGIN_EMAIL = "/api/v1/login/email/"
const REGISTER_MOBILE = "/api/v1/register/phone/"
const LOGIN_MOBILE = "/api/v1/login/phone/"
const SAVE_USER_DETAILS = "api/v1/users/$userId/"
const VERIFY_OTP_SIGNUP_LOGIN = "/api/v1/verify/otp/"
const VERIFY_MOBILE_CONTACT_YOU = "api/v1/users/phone/"
const UPDATE_USER_ADDRESS = "api/v1/users/address/"
const LOGOUT = "/api/v1/users/logout/"
const VIEW_ORDER_ENDPOINT =
  "/api/v1/dating/cart-details/?restaurant_id=$restaurantId"
const INVITE_BY_EMAIL = "api/v1/invite/email/"
const INVITE_BY_PHONE = "api/v1/invite/phone/"
const REJECT_INVITE = "api/v1/invite/reject/"
const FETCH_PARTNER_DETAILS = "/api/v1/dating/partner-details/"
const SECRET_CODE_VERIFICATION = "/api/v1/invite/verify/"
const SEND_OTP = "/api/v1/users/otp/"
const GET_PRESIGNED_URL = "/api/v1/users/upload-media/"
const GET_USER_DATA = "api/v1/users/$userId/"
const SUBSCRIBE_TO_NOTIFY = "/api/v1/subscribe/"
const FORGOT_PASSWORD_URL = "accounts/password_reset/"
const VERIFY_PASSWORD_TOKEN = "accounts/reset/$uuid/$token/"
const PASSWORD_RESET_URL = "accounts/reset/$uuid/$token/set-password/"
const SET_CHATSPACE_NAME = "/api/v1/dating/chat-space/"
const GET_RESTAURANT_MENU = `api/v1/delivery/restaurants/menu/?restaurant_id=$restaurantId`
const GET_CART_ENDPOINT = `/api/v1/delivery/restaurants/cart/?restaurant_id=$restaurantId`
const ADD_ITEMS_TO_CART_ENDPOINT = "/api/v1/delivery/restaurants/add-item/"
const REMOVE_ITEM_FROM_CART_ENDPOINT =
  "/api/v1/delivery/restaurants/remove-item/"
const EMPTY_CART_ENDPOINT = "/api/v1/delivery/restaurants/empty-cart/"
const GET_ADDRESS_FROM_COORD_ENDPOINT = `/api/v1/address/?lat=$latitude&long=$longitude`
const SAME_ADDRESS = `/api/v1/same-address/`
const SAVE_RESTAURANT_SUGGESTION = "/api/v1/users/wish-list/"
const GET_ADDRESS_AUTOCOMPLETE = `/api/v1/autocomplete/?address=$address_input&country=$country_code`
const INVITE_TO_CHAT = "api/v1/invite/chat/"
const CHECK_ADDRESS_ISDELIVERABLE = `/api/v1/delivery/available/?address=$address_input&restaurant_id=$restaurantId`
const GET_ORDERS = `/api/v1/dating/orders/?feedback=False`
const SAVE_RATING = `/api/v1/dating/rating/`
const CHECK_COMMON_RESTAURANTS = `/api/v1/delivery/common-merchants/?address1=$address&address2=$partner_address`
const VALIDATE_ADDRESS = `api/v1/delivery/validate-address/?address=$address&restaurant_id=$restaurantId`
const JOURNAL_ANSWERS = "/api/v1/users/questions/"
const GET_LATEST_ORDER = "/api/v1/dating/partner-order/"
const VERIFY_MAIL_TOKEN = "/api/v1/verify-token/"
const UPLOAD_IMAGE_SUCCESS = "/api/v1/users/profile-image/"
const ADD_TIP = "/api/v1/delivery/restaurants/update-tip/"
const TWILIO_TOKEN = "/api/v1/twilio/token/"

//admin dashboard
const SAVE_SUGGESTION_EVENT = "/api/v1/event/suggestion/"
const SAVE_DATE_EVENT = "/api/v1/event/date/"
const GET_HELP = "/api/v1/feedback/"
const UPDATE_MENU_ITEM = "/api/v1/delivery/restaurants/update-item/"
const SAVE_ORDER = `/api/v1/dating/save-order/`

// End Points of outside world
const PLACE_ORDER =
  "https://api.delivery.com/api/guest/cart/$restaurant_id/checkout/"

export const ENDPOINTS = {
  ADD_ITEMS_TO_CART_ENDPOINT,
  GET_CART_ENDPOINT,
  GET_RESTAURANTS_ENDPOINT,
  GET_ADDRESS_FROM_COORD_ENDPOINT,
  REMOVE_ITEM_FROM_CART_ENDPOINT,
  EMPTY_CART_ENDPOINT,
  GET_RESTAURANT_MENU,
  VERIFY_EMAIL,
  REGISTER_EMAIL,
  LOGIN_EMAIL,
  REGISTER_MOBILE,
  LOGIN_MOBILE,
  SAVE_USER_DETAILS,
  VERIFY_OTP_SIGNUP_LOGIN,
  VERIFY_MOBILE_CONTACT_YOU,
  LOGOUT,
  VIEW_ORDER_ENDPOINT,
  INVITE_BY_EMAIL,
  INVITE_BY_PHONE,
  REJECT_INVITE,
  FETCH_PARTNER_DETAILS,
  SECRET_CODE_VERIFICATION,
  INVITE_TO_CHAT,
  SEND_OTP,
  PLACE_ORDER,
  GET_PRESIGNED_URL,
  UPDATE_USER_ADDRESS,
  GET_USER_DATA,
  FORGOT_PASSWORD_URL,
  VERIFY_PASSWORD_TOKEN,
  PASSWORD_RESET_URL,
  GET_ADDRESS_AUTOCOMPLETE,
  SAME_ADDRESS,
  SUBSCRIBE_TO_NOTIFY,
  CHECK_ADDRESS_ISDELIVERABLE,
  SAVE_ORDER,
  GET_ORDERS,
  SAVE_RATING,
  SAVE_RESTAURANT_SUGGESTION,
  CHECK_COMMON_RESTAURANTS,
  SAVE_SUGGESTION_EVENT,
  SAVE_DATE_EVENT,
  GET_HELP,
  UPDATE_MENU_ITEM,
  SET_CHATSPACE_NAME,
  VALIDATE_ADDRESS,
  JOURNAL_ANSWERS,
  GET_LATEST_ORDER,
  VERIFY_MAIL_TOKEN,
  UPLOAD_IMAGE_SUCCESS,
  ADD_TIP,
  TWILIO_TOKEN,
}
